import Calendar from './Calendar'

export default Calendar



// WEBPACK FOOTER //
// ./components/vc-calendar/src/index.js